import { render, staticRenderFns } from "./WizardMoreDetailsStep.vue?vue&type=template&id=32de0238&scoped=true&"
import script from "./WizardMoreDetailsStep.vue?vue&type=script&lang=js&"
export * from "./WizardMoreDetailsStep.vue?vue&type=script&lang=js&"
import style0 from "./wizard-step-shared.css?vue&type=style&index=0&lang=css&"
import style1 from "./WizardMoreDetailsStep.vue?vue&type=style&index=1&id=32de0238&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32de0238",
  null
  
)

export default component.exports